import api from '@/api/api'
import { parseParams, parseUrlFilters } from './common'

export default {
  getProducts (params, filters = []) {
    const urlParams = parseParams(params)
    const urlFilters = parseUrlFilters('admin_products', filters)
    return api.get(`/products?${urlParams}&${urlFilters}`).then(res => res.data)
  },
  getProductExampleCSV () {
    return api.get('/products/example', { responseType: 'arraybuffer' }).then(res => res.data)
  },
  uploadSimpleCSV (file) {
    const formData = new FormData()
    formData.append('file', file)
    return api.post('/products/upload', formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
  },
  uploadBatchCSV (file) {
    const formData = new FormData()
    formData.append('file', file)
    return api.post('/products/batch-upload', formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
  },
  getBatchUploadState () {
    return api.get('/products/batch-upload/state').then(res => res.data && res.data.state)
  },
  getPriceCSV () {
    return api.get('/products/campaigns/prices', { responseType: 'arraybuffer' }).then(res => res.data)
  },
  uploadPriceCSV (file) {
    const formData = new FormData()
    formData.append('file', file)
    return api.post('/products/campaigns/prices', formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
  }
}
